import styled from 'styled-components'

export const Card = styled.a`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 8px 16px 0px rgba(46, 45, 55, 0.12);
  width: 232px;
  height: 375px;
`;

export const Image = styled.img`
  border-radius: 0px 0px 0px 4px;
  width: 232px;
  height: 172px;
`

export const Title = styled.h2`
  color: #2e2d37 !important;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-transform: uppercase;
  margin-bottom: 8px;
  padding: 0px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 3em;
`;


export const Text = styled.h3`
  font-size: 12px;
  text-transform: uppercase;
  color: #696977;
  margin: 0;
  line-height: 150%;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 3em; 
`;

export const TextWrapper = styled.div`
  padding: 8px 0;
`

export const Price = styled.strong`
  font-size: 20px;
  color: #2e2d37;
  font-weight: 600;
  line-height: 150%;
`

export const DataLabel = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  width: 100%;
  margin-top: 8px;
`

export const DataValue = styled.div`
  color: #696977;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

export const Footer = styled.div`
  font-size: 10px;
  line-height: 2px;
  color: #696977;
  display: flex;
  align-items: center;
  gap: 4px;
  border-top: 1px solid #ecedf2;
  padding: 8px 0 8px 12px;
  height: 25px;
  margin-top: auto; 

   span {
    -webkit-flex: 1 1 0%;
    -ms-flex: 1 1 0%;
    flex: 1 1 0%;
    -webkit-box-flex: 1;
    max-width: 165px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 4px 0 2px 0;
   }
`;


export const Content = styled.div`
  flex: 1;
  padding: 0px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`;

export const Icon = styled.img`
  height: 15px;
  width: 15px;
`
